export enum ReportTypes {
  CUSTOM = 'custom',
  HOME_SALES_CANCELLATIONS = 'homes_sales_and_cancellations',
  QMI = 'qmi',
  TRAFFIC = 'traffic',
}
